import createHttpClient from './HttpClient.js';

const BASE_URL =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL)
    ? process.env.REACT_APP_API_URL
    : (typeof window !== 'undefined' ? window.location.origin : '');

const http = createHttpClient();

/**
 * Obtiene el catálogo de elementos habilitados
 * GET /api/v1/public/elements
 * @returns {Promise<Array<{ code:string, displayName:string, orderPriority:number }>>}
 */
export async function fetchElementsCatalog() {
  const url = `${BASE_URL}/api/v1/public/elements`;
  try {
    const res = await http.get(url, {
      headers: { Accept: 'application/json' },
    });
    return res?.data ?? res;
  } catch (error) {
    const message = error?.message || 'HTTP Error';
    const e = new Error(message);
    if (error && typeof error === 'object') {
      if ('status' in error) e.status = error.status;
      if ('code' in error) e.code = error.code;
      if ('details' in error) e.details = error.details;
    }
    throw e;
  }
}